import type { AxiosResponse } from "axios";

import config from "@/common/config";
import type { LanguageGroup } from "@/types/site";
import type { VoiceSearchResult } from "@/types/voice-search.type";

import ApiService from "./api.service";
import type { ApiResponse } from "./types";

export default {
  VERSION: config.api.versions.v2,

  log(
    className: string,
    languageGroup: LanguageGroup,
    result: VoiceSearchResult[]
  ): Promise<AxiosResponse<ApiResponse<void>>> {
    const data = {
      uniloginClass: className,
      language: languageGroup,
      result
    };

    return ApiService.post("/voice-search/log", data, this.VERSION);
  }
};
